var dropdownWrapper = require('./dropdown-wrapper');
var dropdownItemWrapper = require('vue-tables-2/compiled/modules/dropdown-item-wrapper');

module.exports = function(h) {
    return classes => {
        var fixed = this.opts.columnsDropdownFixed || [];
        var cols = this.columns.map(column => {
            var isFixed = fixed.indexOf(column) !== -1;
            return dropdownItemWrapper(
                h,
                classes,
                <a
                    class={classes.dropdown.item}
                    on-click={() => {
                        if (!isFixed && !this._onlyColumn(column))
                            this.toggleColumn(column);
                    }}
                >
                    <input
                        type="checkbox"
                        value={column}
                        disabled={isFixed || this._onlyColumn(column)}
                        checked={this.allColumns.includes(column)}
                    />
                    <span class="m-l-sm">{this.getHeading(column)}</span>
                </a>,
            );
        });

        return (
            <div
                class={`${classes.dropdown.container} ${
                    classes.right
                } VueTables__columns-dropdown`}
            >
                <button
                    type="button"
                    class={`btn ${classes.dropdown.trigger} btn-fw white`}
                    data-toggle="dropdown"
                >
                    {this.display('columns')}
                    <span class={`${classes.icon} ${classes.small}`}>
                        <i class={classes.dropdown.caret} />
                    </span>
                </button>

                {dropdownWrapper.call(this, h, classes, cols)}
            </div>
        );
    };
};
